export type TreatmentKey = 'sildenafil' | 'tadalafil';

export interface TreatmentRecommendation {
  treatmentKey: TreatmentKey;
  name: string;
  description: string;
}

export type AnswersMap = Record<string, unknown>;

export function getEdTreatmentRecommendation(answers: AnswersMap): TreatmentRecommendation | null {
  const pref = answers['ed_1_treatment_preference'];

  if (pref === 'A') {
    return {
      treatmentKey: 'sildenafil',
      name: 'Sildenafil',
      description:
        'The generic version of Viagra. Same active ingredient, same results, better value. Good for planned moments when you want predictable timing.',
    };
  }

  if (pref === 'B') {
    return {
      treatmentKey: 'tadalafil',
      name: 'Tadalafil',
      description:
        'The unbranded version of Cialis. Long-lasting and ideal for flexibility. Good if you prefer all-day confidence and less timing pressure.',
    };
  }

  return null;
}
